// extracted by mini-css-extract-plugin
export default {"container":"style-container-3NINX","content":"style-content-2KjTy","shell":"style-shell-yGc4T","subheader":"style-subheader-2OFvX"};